var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#6FE1B8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_2688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#DBEBFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_2688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.789 67.0461C60.503 67.2777 60.2081 67.5003 59.9064 67.7116C57.0999 69.697 53.6901 70.8572 50.01 70.8572C46.3298 70.8572 42.9156 69.6948 40.1091 67.7094C39.794 67.4868 39.4857 67.2529 39.1863 67.0079V57.3193C40.9738 57.4384 42.7324 58.3356 44.2719 59.3406C46.274 60.6447 48.2224 62.2007 50.5597 62.6751C52.9215 63.154 55.6408 62.5289 57.5714 63.9927C58.1635 64.4446 58.6149 65.0495 59.1176 65.6003C59.6204 66.1445 60.1857 66.6301 60.7913 67.0438L60.789 67.0461Z",
    fill: "#BED1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8315 56.1366V67.0776C60.8181 67.0686 60.8047 67.0596 60.7913 67.0483C60.1835 66.6346 59.6204 66.149 59.1176 65.6048C58.6149 65.0562 58.1635 64.4491 57.5714 63.9972C55.6431 62.5312 52.9237 63.1563 50.5597 62.6796C48.2247 62.2052 46.274 60.6515 44.2719 59.3451C42.7301 58.3401 40.9738 57.443 39.1863 57.3238V56.1388H60.8315V56.1366Z",
    fill: "#BED1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3767 44.2041V32.8898C31.9377 32.8898 30.7736 34.0635 30.7736 35.5093V41.5824C30.7736 43.0304 31.9399 44.2018 33.3767 44.2018V44.2041Z",
    fill: "#B6BFE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4601 44.2041V32.8898C67.8991 32.8898 69.0632 34.0635 69.0632 35.5093V41.5824C69.0632 43.0304 67.8968 44.2018 66.4601 44.2018V44.2041Z",
    fill: "#B6BFE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1365 26.4637C41.8386 26.6908 36.7284 24.8673 32.4315 22.8077V42.5469C32.4315 48.5301 35.3989 53.8139 39.9348 56.991C42.7659 58.9764 46.207 60.1388 49.9184 60.1388C53.6298 60.1388 57.0687 58.9764 59.8997 56.9932C62.1856 55.3923 64.0715 53.2563 65.3808 50.765C63.6424 45.9938 64.2815 40.3389 62.7688 34.9134C60.9387 28.3479 54.3516 26.1512 47.1387 26.4615L47.1365 26.4637Z",
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4008 18.6054H32.4315V22.81C36.7284 24.8696 41.8386 26.6931 47.1365 26.466C54.3493 26.1557 60.9365 28.3524 62.7665 34.9179C64.277 40.3434 63.6402 45.9983 65.3786 50.7695C66.6701 48.3164 67.4008 45.5194 67.4008 42.5492V18.6054Z",
    fill: "#BED1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2178 22.5065C37.2178 22.5065 38.3037 24.4536 43.0162 24.9033C47.4873 25.3305 60.5053 20.7639 63.6559 26.8437C68.6499 36.4806 66.0333 39.2867 67.622 39.3856C68.88 39.4643 68.5471 28.7077 68.5471 28.7077L69.9213 28.1321C69.9213 28.1321 70.9491 22.6481 69.0543 17.2563C67.3472 12.3997 63.0503 10.041 63.0503 10.041L65.3407 8.42888C65.3407 8.42888 46.1735 1.01123 36.4625 8.00168C31.1043 11.8578 30.711 17.7465 29.9558 21.4497C29.3413 24.4626 29.7949 28.7054 29.7949 28.7054L31.2674 27.6374C31.2674 27.6374 30.4205 39.1405 32.121 39.3856C32.722 39.4733 32.6081 35.8263 32.7153 34.4412C33.6091 23.0348 37.2155 22.5065 37.2155 22.5065H37.2178Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4088 67.3114L48.8794 67.4665L49.1878 71.2349L49.1274 72.8224H51.315L51.4088 67.3114Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.315 72.8224L51.2859 74.7223L50.8725 101.142L50.8301 103.856L50.8122 104.993C50.5441 105 50.2715 105.002 49.9989 105.002C49.7263 105.002 49.4559 105.002 49.1855 104.993L49.038 103.788L48.5196 99.4778V99.4733L48.2269 97.0517L49.1252 72.8224H51.3127H51.315Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5586 66.2951H50.8123V72.8224H50.9664L50.9642 72.7976L53.0847 70.8909L53.1785 70.8055L54.6913 69.4474L51.5586 66.2951Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2492 63.6712C63.1062 63.5228 62.99 63.3766 62.9051 63.235C62.8492 63.1428 62.771 63.0124 62.6816 62.8595C62.123 61.8971 61.0616 59.8983 60.8292 58.6234L50.8099 66.0545V67.6667L53.0824 70.8954L53.8287 71.9545L56.0609 75.1293L62.2414 64.3434L61.7096 66.131L63.2514 63.6734L63.2492 63.6712Z",
    fill: "#D4E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 77.4182C85.0933 93.2113 69.6488 104.368 51.5519 104.973L54.1908 101.598L69.1527 82.4615L65.1955 76.0669L69.1527 74.9831L65.3228 65.1439C68.7371 67.0641 75.179 69.4002 82.6622 72.1681C86.548 73.6071 89.7097 74.032 92.0023 77.4182H92Z",
    fill: "#546EDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2556 92.4222L54.117 91.5925L53.4623 93.7915L52.1864 80.0916L50.9664 72.8224H50.8123V103.856H50.8815L54.9818 100.231L54.2556 92.4222Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2414 64.339L61.7074 66.1265L54.1169 91.5925L53.4622 93.7915L52.1864 80.0916L50.9663 72.8224L50.9641 72.7976L53.0846 70.891L53.8287 71.95L56.0609 75.1248L62.2414 64.339Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4414 66.2951H49.1877V72.8224H49.0313L49.0358 72.7976L46.9153 70.8909L46.8192 70.8055L45.3087 69.4474L48.4414 66.2951Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7486 63.6712C36.8916 63.5228 37.0078 63.3766 37.0927 63.235C37.1485 63.1428 37.2267 63.0124 37.3161 62.8595C37.8747 61.8971 38.9562 59.8983 39.1886 58.6234L49.1878 66.0545V67.6667L46.9154 70.8954L46.1691 71.9545L43.9368 75.1293L37.7563 64.3434L38.2881 66.131L36.7463 63.6734L36.7486 63.6712Z",
    fill: "#D4E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4482 104.973C30.3468 104.368 14.9045 93.2113 8 77.4205C10.2903 74.032 13.4521 73.6071 17.34 72.1681C24.8232 69.4002 31.2652 67.0641 34.6794 65.1439L30.8496 74.9831L34.8046 76.0669L30.8496 82.4615L45.8115 101.598L48.4504 104.973H48.4482Z",
    fill: "#546EDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7422 92.4222L45.883 91.5925L46.5377 93.7915L47.8113 80.0916L49.0313 72.8224H49.1877V103.856H49.1185L45.016 100.231L45.7422 92.4222Z",
    fill: "#3450C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7585 64.339L38.2903 66.1265L45.883 91.5925L46.5377 93.7915L47.8114 80.0916L49.0314 72.8224L49.0359 72.7976L46.9154 70.891L46.1691 71.95L43.9368 75.1248L37.7585 64.339Z",
    fill: "#E4ECF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8122 66.05H49.1877V67.6622H50.8122V66.05Z",
    fill: "#546EDB",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1932 76.0669L69.1504 82.4615L54.1884 101.598L51.5495 104.973C51.3038 104.982 51.058 104.986 50.8122 104.991C50.544 104.998 50.2714 105 49.9988 105C49.7262 105 49.4559 105 49.1855 104.991C48.9397 104.986 48.6917 104.982 48.4481 104.973L45.8092 101.598L30.8473 82.4615L34.8023 76.0669L30.8473 74.9831L34.6772 65.1439C35.6022 64.6222 36.3061 64.1321 36.7463 63.6711C36.8915 63.5227 37.0055 63.3766 37.0904 63.2327C37.1462 63.1405 37.2222 63.0101 37.3138 62.8572L37.43 63.2484L37.754 64.3389L38.288 66.1287L45.8807 91.5925L46.5354 93.7914L48.5196 99.4733V99.4778L49.1855 101.384L49.6391 102.682L49.9832 103.5L50.3273 102.682L50.8099 101.315L50.8703 101.144L53.46 93.7937L54.1147 91.5947L61.7074 66.131L62.2392 64.3412L62.5632 63.2507L62.6816 62.8595C62.771 63.0123 62.847 63.1428 62.9051 63.2349C62.99 63.3788 63.1062 63.5228 63.2492 63.6734C63.6916 64.1343 64.3932 64.6245 65.3205 65.1461L69.1504 74.9854L65.1932 76.0691V76.0669Z",
    fill: "#3450C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ac84e8b5c1f52cee52cbecece3c76e70.svg";
export { ForwardRef as ReactComponent };